<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps({
    stepsConfig: {
        type: Array,
        default: () => []
    },
    currentStep: {
        type: Number,
        default: -1
    },
    alignment: {
        // inline | incolumn
        type: String,
        default: 'inline',
    }
});

const stepTexts = computed(() => {
    const step = props.currentStep
    return step >= 0 ? props.stepsConfig[step] : {title: '', subtitle: ''}
})

</script>
<template>
    <div v-if="currentStep >= 0" :class="`box--${alignment}`">
        <div :class="`box_content--${alignment}`">
            <div><div class="spinner"></div></div>
            <div class="infos">
                <div class="title" :class="{'title--incolumn': alignment === 'incolumn'}">
                    <div>{{stepTexts.title}}</div>
                    <div class="dots_loader"></div>
                </div>
                <div class="subtitle" :class="{'subtitle--incolumn': alignment === 'incolumn'}">{{ stepTexts.subtitle }}</div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="postcss">
.box--inline {
    @apply flex items-center justify-between
}
.box--incolumn {
    @apply flex items-center justify-center
}

.box_content--inline {
    @apply gap-2 items-center grid;
    grid-template-columns: 40px 1fr;
}

.box_content--incolumn {
    @apply gap-2 items-center flex flex-col
}

.infos {
    @apply flex flex-col
}

.title {
    @apply text-sm 2xl:text-base flex gap-1 items-end
}

.title--incolumn {
    @apply text-center justify-center
}

.subtitle {
    @apply text-xs 2xl:text-sm text-white/50
}

.subtitle--incolumn {
    @apply text-center
}

.dots_loader {
    margin-bottom: 2px;
    width: 16px;
    height: 3px;
    background: radial-gradient(circle closest-side,#ffffff 90%,#ffffff00) 0/calc(100%/3) 100% space;
    clip-path: inset(0 100% 0 0);
    animation: l1 1s steps(4) infinite;
}
@keyframes l1 {to{clip-path: inset(0 -34% 0 0)}}

.spinner {
    @apply w-10 h-10;
    border: 4px solid rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    border-top: 4px solid #FE3E01;
    animation: spin 1s linear infinite;
  }
</style>